import React, { createContext, useContext } from "react"

import { AnchorProps } from "shared/ui/link/Anchor"

interface ProjectPageProductPositionSidebarContextValue {
  image?: React.ReactNode
  titleLinkProps?: AnchorProps
}

const ProjectPageProductPositionSidebarContext = createContext<
  ProjectPageProductPositionSidebarContextValue | undefined
>(undefined)

export const ProjectPageProductPositionSidebarProvider = React.memo(
  ({
    value,
    children
  }: {
    value: ProjectPageProductPositionSidebarContextValue
    children: React.ReactNode
  }) => (
    <ProjectPageProductPositionSidebarContext.Provider value={value}>
      {children}
    </ProjectPageProductPositionSidebarContext.Provider>
  )
)

export function useProjectPageProductPositionSidebarContext() {
  return useContext(ProjectPageProductPositionSidebarContext)
}
